import { Navigate, Route, Routes } from "react-router-dom";
import { MainInterface } from "@components/mainInterface/MainInterface";
import { WorkspacesPage } from "@components/personalView/Workspaces/WorkspacesPage";
import { PersonalViewNavigation } from "@components/personalView/PersonalViewNavigation";
import { PersonalViewUserDropdownItems } from "@components/personalView/PersonalViewUserDropdownItems";
import { useRenderCommonRoutes } from "./useRenderCommonRoutes";

export const PersonalViewRoutes = () => {
    const commonRoutes = useRenderCommonRoutes();

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <MainInterface
                        navigation={<PersonalViewNavigation />}
                        dropdownItems={<PersonalViewUserDropdownItems />}
                        breadcrumbs={[{ label: "Workspaces" }]}
                    >
                        <WorkspacesPage />
                    </MainInterface>
                }
            />
            {commonRoutes}

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};
